module.exports = __webpack_public_path__ + "facebook_logo.74642f72ffe0a5e867ddad188dfbff46.png";